
import { component } from '@/helpers/vueTyped';
import { Summary } from '@/api/validators/content';
import { dispatch } from '@/store';
import { config } from '@/config';
import HighlightSection from '@/components/SharedViews/HighlightSection/HighlightSection.vue';
import CardRailContainer from '@/components/SharedViews/CardRail/CardRailContainer.vue';
import HomeBackground from '@/components/SharedViews/Background/HomeBackground.vue';

export default component()({
  name: 'SportHome',

  data() {
    return {
      focusedCardSummary: undefined as Summary | undefined,
      hideArticleRail: false,
    };
  },

  methods: {
    focus() {
      this.hideArticleRail = false;
      (this.$refs.articlerail as InstanceType<typeof CardRailContainer>).focus();
    },

    cardFocusHandler(summary: Summary) {
      dispatch('setBackgroundOptions', [{ url: `${config.cdn}${summary.image}`, type: 'home' }]);

      this.focusedCardSummary = summary;
    },

    newsRailFocusHandler() {
      this.hideArticleRail = false;
    },

    videoRailFocusHandler() {
      this.hideArticleRail = true;
    },
  },

  render() {
    return (
      <div v-spatial-container tabindex={1} onFocus={this.focus}>
        <HighlightSection class='highlight-section' summary={this.focusedCardSummary}/>
        <div class='rails-container'>
          <CardRailContainer
            ref='articlerail'
            class={['rail', this.hideArticleRail && 'hide-rail']}
            onFocus={this.newsRailFocusHandler}
            cardFocusCallback={this.cardFocusHandler}
            firstCardLoadedCallback={this.cardFocusHandler}
            feedType='article'
            summaryType='articles'
            categoryName='Latest News'
          />
          <CardRailContainer
            class='rail video-rail'
            onFocus={this.videoRailFocusHandler}
            cardFocusCallback={this.cardFocusHandler}
            feedType='video'
            summaryType='video'
            categoryName='Latest Video'
          />
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-ce434862/SportHome.vue" });